import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedVcIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_14099_6404)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M15.75 6.67628L18.4059 5.3127C18.4948 5.26707 18.5936 5.24553 18.6929 5.25012C18.7922 5.25471 18.8887 5.28529 18.9733 5.33894C19.0578 5.3926 19.1276 5.46756 19.1761 5.5567C19.2245 5.64585 19.2499 5.74622 19.25 5.84831V9.90072C19.2499 10.0028 19.2245 10.1032 19.1761 10.1923C19.1276 10.2815 19.0578 10.3564 18.9733 10.4101C18.8887 10.4637 18.7922 10.4943 18.6929 10.4989C18.5936 10.5035 18.4948 10.482 18.4059 10.4363L15.75 9.07274V6.67628Z",
					stroke: "#333333",
					strokeWidth: 1.25,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.875 4.81201C7.875 4.46392 8.01328 4.13008 8.25942 3.88393C8.50556 3.63779 8.8394 3.49951 9.1875 3.49951H14.4375C14.7856 3.49951 15.1194 3.63779 15.3656 3.88393C15.6117 4.13008 15.75 4.46392 15.75 4.81201V10.062C15.75 10.4101 15.6117 10.7439 15.3656 10.9901C15.1194 11.2362 14.7856 11.3745 14.4375 11.3745H9.1875C8.8394 11.3745 8.50556 11.2362 8.25942 10.9901C8.01328 10.7439 7.875 10.4101 7.875 10.062V4.81201Z",
					stroke: "#333333",
					strokeWidth: 1.25,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4.35938 7.14404C4.7585 7.14404 5.11991 7.352 5.3252 7.67627L5.40332 7.82275L5.40625 7.82959L6.39258 10.1265L6.40332 10.1509L6.41113 10.1753C6.42465 10.2158 6.48438 10.3766 6.48438 10.5581C6.48438 10.9237 6.30602 11.2384 6.06934 11.4302L6.07031 11.4312L5.20996 12.1343C5.84294 13.2611 6.76608 14.1831 7.89551 14.8149L8.60254 13.9556C8.78533 13.7308 9.09687 13.5426 9.45508 13.5425C9.5517 13.5425 9.63732 13.5552 9.70605 13.5708L9.8584 13.6157L9.88281 13.6235L9.90723 13.6343L12.208 14.6187L12.2246 14.6255L12.2412 14.6333C12.6127 14.8187 12.875 15.2172 12.875 15.6646V15.8384L12.8594 15.9077L12.3662 18.0405L12.3633 18.0532L12.3594 18.0649C12.2262 18.5517 11.8025 18.894 11.2842 18.894C5.65936 18.894 1.125 14.3702 1.125 8.75342C1.125 8.23377 1.46983 7.81057 1.95605 7.67822L1.97949 7.67236L4.11621 7.18018L4.18555 7.16455H4.19727C4.2092 7.16167 4.22455 7.1579 4.24219 7.15479C4.26647 7.15049 4.30798 7.14406 4.35938 7.14404Z",
					stroke: "#333333",
					strokeWidth: 1.25
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_14099_6404",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 21,
				height: 21,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgOutlinedVcIcon);
const Memo = memo(ForwardRef);
export default Memo;
